import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { Language } from '@libs/models';
import { CommonModule } from '@angular/common';
import { CaFooterComponent } from '@global-front-components/ui/footer';
import packageJson from '../../../../package.json';
import { GlobalMessageComponent } from './comun/components/global-message/global-message.component';
import { HeaderComponent } from './comun/components/header/header.component';
import { AuthStoreService } from './comun/services/store/auth-store.service';

@Component({
	selector: 'app-component',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	standalone: true,
	imports: [
		CommonModule,
		HeaderComponent,
		CaFooterComponent,
		GlobalMessageComponent,
		RouterOutlet,
		TranslateModule]
})
export class AppComponent implements OnInit {
	versionTag = environment.versionTag;
	languageList: Array<Language> = [
		{ code: 'es', label: 'Español' },
		{ code: 'en', label: 'English' }
	];
	selectedLanguage = this.translateService.getDefaultLang();
	version = packageJson.version;
	nombre = packageJson.name;
	anio = new Date().getFullYear();
	logueado: boolean;
	public esEmbebido: boolean;
	public contenedor: any;

	constructor(
		private translateService: TranslateService,
		private authStore: AuthStoreService,
		private router: Router
	) { }

	ngOnInit(): void {
		this.authStore.getLoggedInStatus().subscribe((isLoggedIn) => {
			this.logueado = isLoggedIn;
			if (this.logueado) {
				this.authStore.getUsuarioConectado().subscribe((usuario) => {
					if (usuario) {
						if (usuario.embebido !== null && usuario.embebido !== undefined) {
							this.esEmbebido = usuario.embebido;
						}
						if (usuario.tema !== null && usuario.tema !== undefined) {
							this.authStore.cargarTema(usuario.tema);		
						}
					}			
				});
			}
		});
		this.authStore.getContenedorObservable().subscribe((contenedor) => {
			this.contenedor = contenedor;
		});
	}

	logout(): void {
		this.authStore.logout();
		this.router.navigate(['/login']);
	}
}

